import React from 'react';
import { Link } from 'react-router-dom';
import APP_DEFAULTS from '../../constants/app-defaults';

import APP_ROUTES from '../../constants/app-routes';

const ClearFilter = (props) => (
    <div className="col-xs-10 col-sm-10 col-md-10" style={{ marginBottom: 10, marginTop: 5 }} onClick={() => props.setParams()}>
        <Link
            to={{ pathname: APP_ROUTES.searchPageRoute }}
            className="pull-right"
            style={{
                color: APP_DEFAULTS.theme.clearFilterColor, fontWeight: 'bold', fontSize: 12, fontFamily: 'Lato Bold',
            }}
        >
            {props.title}
        </Link>
    </div>
);

export default ClearFilter;



/** WEBPACK FOOTER **
 ** ./src/components/shared/clear-filter.jsx
 **/